var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinBranco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.852,
    height: 77.851,
    viewBox: "0 0 77.852 77.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M747,286.289c.2-1.5.329-3.012.613-4.495a38.344,38.344,0,0,1,20.053-27.576,36.089,36.089,0,0,1,19.889-4.508c14.609.9,25.559,7.835,32.7,20.6a35.648,35.648,0,0,1,4.52,19.884c-.9,14.64-7.861,25.586-20.652,32.749a36.034,36.034,0,0,1-15.339,4.425,4.139,4.139,0,0,0-.587.125H783.64a4.05,4.05,0,0,0-.587-.125,35.907,35.907,0,0,1-13.642-3.566c-11.937-5.884-19.243-15.369-21.8-28.457-.289-1.481-.413-2.994-.614-4.492Zm38.912-33.111a35.391,35.391,0,1,0,35.4,35.382A35.439,35.439,0,0,0,785.912,253.178Z",
    transform: "translate(-747 -249.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M952.521,445.535H945.5v-.792c0-3.116.007-6.232-.006-9.347a11.935,11.935,0,0,0-.135-1.89,2.167,2.167,0,0,0-1.748-2.039A2.471,2.471,0,0,0,940.9,432.7a6.952,6.952,0,0,0-.675,2.674c-.079,3.19-.03,6.383-.032,9.575,0,.174-.017.348-.03.572H933.2v-19.36h6.95v2.494a13.07,13.07,0,0,1,2.527-1.856c2.6-1.092,5.852-1.065,7.8,1.179a8.081,8.081,0,0,1,1.97,5.078c.142,4.073.11,8.153.146,12.23A1,1,0,0,1,952.521,445.535Z",
    transform: "translate(-897.749 -392.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M877.29,445.784V426.408h6.972v19.376Z",
    transform: "translate(-852.481 -392.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M884.176,383.318a3.522,3.522,0,1,1-3.55-3.494A3.506,3.506,0,0,1,884.176,383.318Z",
    transform: "translate(-852.353 -355.035)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBranco);
export default __webpack_public_path__ + "static/media/linkedin-branco.7f7e0b1d91040d58b05ad59f98ae36b7.svg";
export { ForwardRef as ReactComponent };